export function calculateCurrentPage(page, pageSize, total) {
  let end = page * pageSize;
  if (end > total) {
    end = total;
  }
  return `${end}`;
}

export function calculateCurrentPageFull(page, pageSize, total) {
  let start = page > 1 ? (page - 1) * pageSize + 1 : 1;
  let end = page * pageSize;
  if (end > total) {
    end = total;
  }
  return `${start} - ${end}`;
}
